import React, { Component } from 'react';

import Header from "../assets/img/ban.jpg";


const styles = {
    banner:{
        backgroundImage: 'url(' + Header + ')',
    },
}

class SearchHeader extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="searchheader" style={{backgroundImage: "url(https://mportalsystem2.btect.sk/"+ this.props.findImageBySlug("vysledky_banner")}} >
                <div className="headover"></div>
                <h2 className="white">{this.props.findSlug('nadpis_vysledky')}</h2>
            </div>
        );
    }

}
export default SearchHeader;